import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { AudioAnalysisProvider } from './contexts/AudioAnalysisContext';

// Components
import NavigationBar from './shared/NavigationBar';

// Layout
import AILayout from './pages/AILayout';

// Styles
import './App.css';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AudioAnalysisProvider>
          <Router>
            <div className="app">
              <NavigationBar />
              <main className="app-content">
                <Routes>
                  <Route path="/*" element={<AILayout />} />
                </Routes>
              </main>
            </div>
          </Router>
        </AudioAnalysisProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
